import { Switch, SwitchProps } from '@mantine/core';

export const MeSwitch = (props: SwitchProps & { value: boolean | string }) => {
  const isChecked = props.value === true || props.value === 'checked';
  return <Switch checked={isChecked} {...props} />;
};
